import React from 'react';
import { isEmpty } from 'lodash';
import { SaveToListPopover, SaveToListButton as BaseSaveToListButton } from '@fiverr-private/collect_actions';

interface SaveToListProps {
    sellerId?: string;
    withLabel?: boolean;
    size?: 'sm' | 'md';
}

export const SaveToListButton = ({ sellerId, withLabel = false, size = 'sm' }: SaveToListProps) => {
    if (!sellerId) {
        return null;
    }

    return (
        <SaveToListPopover
            resourceType="SELLER"
            resourceId={sellerId}
            position="bottom-end"
            fullWidth
            renderTrigger={({ inCollections }) => (
                <BaseSaveToListButton
                    size={size}
                    variant={withLabel ? 'labeled' : undefined}
                    checked={!isEmpty(inCollections)}
                />
            )}
        />
    );
};
